<template>
  <div style="text-align: left">
    <h1 style="margin: 20px;padding-left: 30px">上传页</h1>
    <Form :model="addInfo" :label-width="100" style="margin-top: 100px">
      <FormItem label="类型:">
        <RadioGroup v-model="fileType">
        <Radio label="图片"></Radio>
        <Radio label="视频"></Radio>
        <Radio label="gif"></Radio>
      </RadioGroup>
      </FormItem>
      <FormItem label="名字:">
        <Input v-model="addInfo.name" placeholder="请输入名字,可以为空" style="width: 500px"/>
      </FormItem>
      <FormItem label="标签:">
        <Input v-model="addInfo.tags" placeholder="请输入标签,以,分割" style="width: 500px"/>
        <span style="color: red">*&nbsp;注意:&nbsp;&nbsp;&nbsp;以,分割</span>
      </FormItem>
      <FormItem label="时间:">
        <DatePicker type="date" placeholder="Select date" @on-change="dateChange"></DatePicker>
      </FormItem>
      <FormItem label="文件:">
        <Button type="default" icon="ios-cloud-upload-outline" @click="file">上传文件</Button>
        <input type="file" v-show="false" multiple id="file"  @change="fileChange">
        <br>
        <span>{{addInfo.fileName}}</span>
      </FormItem>
      <FormItem>
        <Button v-show="uploadStatus" type="primary" @click="upload">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
  import {ajaxFetchFile} from '../utils'
  export default {
    name: 'UploadPage',
    data () {
      return {
        date: '',
        fileType: '图片',
        fileData: '',
        uploadStatus: true,
        addInfo: {
          name: '',
          paperCategoryId: 137,
          tags: '',
          fileName: '',
        },
      }
    },
    mounted: function () {

    },
    methods: {
      dateChange (val) {
        this.date = val
      },
      // 图片更改
      fileChange: function (e) {
        this.addInfo.fileName = e.target.files[0].name
        this.fileData = e.target.files[0]
      },
      // 图片选择
      file: function () {
        document.getElementById('file').click()
      },
      upload: function () {
        if(this.fileData){
          this.uploadStatus = false
          let formData = new FormData()
          if (this.fileType === '图片') {
            formData.append('paperCategoryId', this.addInfo.paperCategoryId)
          }else if(this.fileType === '视频') {
            formData.append('paperCategoryId', 138)
          }else if(this.fileType === 'gif') {
            formData.append('paperCategoryId', 139)
          }
          formData.append('tags', this.addInfo.tags)
          formData.append('name', this.addInfo.name)
          formData.append('file', this.fileData)
          formData.append('date', this.date)
          ajaxFetchFile('post','/admin/productTable/add',formData,(response) => {
            if (response.code === 200) {
              this.$Message.success('上传成功');
              this.uploadStatus = true
            } else {
              this.$Message.error('上传失败,可能是类型选择有误');
              this.uploadStatus = true
            }
          }, (err) => {
            this.$Message.error('上传失败');
            this.uploadStatus = true
          } )
        }else {
          this.$Message.error('请上传文件或等待文件加载');
        }

      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UploadPage.vue